import { EParticleShadingMode } from "./particles";
import { MathLerp } from "./utils";

export const FlameParticlesDesc = {
    inName: "Flame Particles",
    inNumSpawners2D: 64,
    inNumParticlesPerSpawner: 1,
    inSpawnRange: { x: 10.0 + Math.random() * 100.0, y: 1000.0 }, //TODO:depends on temperature
    inParticleLife: 2.4,
    inNumLoops: 3.0,
    inTextureFileName: "Flame02_16x4",
    inFlipbookSizeRC: { x: 16.0, y: 4.0 },
    inDefaultSize: { x: 0.2 * 1.0, y: 0.5 * 1.0 },
    inSizeRangeMinMax: { x: 0.45, y: 1.2 },
    inSizeClampMax: { x: 0.35, y: 0.0 },
    inInitialVelocityScale: 0.0,
    inVelocityFieldForceScale: 0.0,
    inBuoyancyForceScale: 0.0,
    inbOriginAtCenter: false,
    inEAlphaFade: 1,
    inRandomSpawnThres: 0.1,
    inBrightness: 1.0,
    inESpecificShadingMode: EParticleShadingMode.Flame,
    inEFadeInOutMode: 3,

    inInitialTranslate: { x: 0.0, y: 0.9 },
};

export function GetEmberParticlesDesc() {
    return {
        inName: "Ember Particles",
        inNumSpawners2D: 32,
        inNumParticlesPerSpawner: 1,
        inSpawnRange: { x: 0.1, y: 100000.0 },
        inParticleLife: 2.8,
        inNumLoops: 1.0,
        inTextureFileName: "",
        inFlipbookSizeRC: { x: 16.0, y: 4.0 },
        inDefaultSize: { x: 0.125 * 0.1, y: 0.125 * 0.1 },
        inSizeRangeMinMax: { x: 0.5, y: 1.25 },
        inRandomSizeChangeSpeed: 0.1,
        inSizeClampMax: { x: 0.0, y: 0.0 },
        inInitialVelocityScale: MathLerp(30.0, 120.0, Math.random()),
        inVelocityFieldForceScale: MathLerp(70.0, 300.0, Math.random()),
        inBuoyancyForceScale: 5.0,
        inDownwardForceScale: 1.0,
        inbOriginAtCenter: true,
        inbMotionBasedTransform: true,
        inEFadeInOutMode: 0,
        inbOneShotParticle: false,
        inEInitialPositionMode: 0,
        inRandomSpawnThres: 0.1,
        inESpecificShadingMode: EParticleShadingMode.Embers,
    };
}

export const SmokeParticlesDesc = {
    inName: "Smoke Particles",
    inNumSpawners2D: 32,
    inNumParticlesPerSpawner: 2,
    inSpawnRange: { x: MathLerp(20.0, 200.0, Math.random()), y: 1000.0 },
    inParticleLife: 3.5,
    inNumLoops: 1.0,
    inTextureFileName: "Explosion01-nofire_5x5",
    inFlipbookSizeRC: { x: 5.0, y: 5.0 },
    inDefaultSize: { x: 2.0 * 0.275, y: 2.125 * 0.275 },
    inSizeRangeMinMax: { x: 0.7, y: 1.0 },
    inSizeClampMax: { x: 0.7, y: 0.7 },
    inInitialVelocityScale: 5.0,
    inVelocityFieldForceScale: 20.0,
    inBuoyancyForceScale: 10, //TODO:Increase dynamically when overall temperature is high
    inDownwardForceScale: 0.25,
    inRandomSizeChangeSpeed: 0.01,
    inAlphaScale: 0.25,
    inEAlphaFade: 1,
    inbOriginAtCenter: true,
    inBrightness: 1.0,
    inEFadeInOutMode: 1,
    inESpecificShadingMode: EParticleShadingMode.Smoke,
};

export const AfterBurnSmokeParticlesDesc = {
    inName: "After Burn Smoke Particles",
    inNumSpawners2D: 4,
    inNumParticlesPerSpawner: 1,
    inSpawnRange: { x: 0.001, y: 1.0 },
    inParticleLife: 12.7,
    inNumLoops: 4.0,
    inTextureFileName: "DiscSmoke01_16x4",
    inFlipbookSizeRC: { x: 16.0, y: 4.0 },
    inDefaultSize: { x: 2.0 * 0.35, y: 3.525 * 0.35 },
    inSizeRangeMinMax: { x: 0.99, y: 1.01 },
    inSizeClampMax: { x: 1.0, y: 1.0 },
    inInitialVelocityScale: 1.1,
    inVelocityFieldForceScale: 1.0,
    inBuoyancyForceScale: 0,
    inDownwardForceScale: 0.0,
    inbOriginAtCenter: false,
    inbMotionBasedTransform: false,
    inEAlphaFade: 1,
    inAlphaScale: 0.5,
    inBrightness: 0.0,
    inRandomSpawnThres: 0.05,
    inEFadeInOutMode: 0,
    inESpecificShadingMode: EParticleShadingMode.AfterBurnSmoke,
    inInitSpawnPosOffset: { x: 0.2, y: 0.0 },
    inInitialTranslate: { x: 0.0, y: 0.95 },
};

export const AfterBurnAshesParticlesDesc = {
    inName: "Ashes Particles",
    inNumSpawners2D: 16,
    inNumParticlesPerSpawner: 1,
    inSpawnRange: { x: 0.001, y: 10.0 },
    inParticleLife: 6.8,
    inNumLoops: 1.0,
    //inTextureFileName: "",
    inTextureFileName: "perlinNoise512",
    inFlipbookSizeRC: { x: 5.0, y: 5.0 },
    inDefaultSize: { x: 0.075, y: 0.075 },
    inSizeRangeMinMax: { x: 0.45, y: 1.0 },
    inSizeClampMax: { x: 0.0, y: 0.0 },
    inInitialVelocityScale: 10.0,
    inVelocityFieldForceScale: 50.0,
    inBuoyancyForceScale: MathLerp(5.0, 20, Math.random()),
    inDownwardForceScale: 0.1,
    inbOriginAtCenter: true,
    //inEFadeInOutMode: 2,
    inESpecificShadingMode: EParticleShadingMode.Ashes,
};

export const DustParticlesDesc = {
    inName: "Dust Particles",
    inNumSpawners2D: 48,
    inNumParticlesPerSpawner: 1,
    inSpawnRange: { x: 0.0, y: 1.0 },
    inParticleLife: 20.8,
    inNumLoops: 1.0,
    //inTextureFileName: "",
    inTextureFileName: "perlinNoise512",
    inFlipbookSizeRC: { x: 5.0, y: 5.0 },
    inDefaultSize: { x: 0.01, y: 0.01 },
    inSizeRangeMinMax: { x: 0.45, y: 1.35 },
    inSizeClampMax: { x: 0.0, y: 0.0 },
    inRandomSizeChangeSpeed: 0.2,
    inInitialVelocityScale: 2.0,
    inVelocityFieldForceScale: 2.0,
    inBuoyancyForceScale: 0.0,
    inDownwardForceScale: 2.0,
    inbOriginAtCenter: true,
    inEInitialPositionMode: 1,
    inRandomSpawnThres: 0.5,
    inEAlphaFade: 1,
    inEFadeInOutMode: 0,
    inESpecificShadingMode: EParticleShadingMode.Dust,
};
